import React from "react";
import { string, bool, object } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import NavigateIcon from "../icons/navigate";

import "./profile-menu-item.m.css";

const ProfileMenuItem = ({ type, label, isActive, isNavigateIcon, href, publisherAttributes }) => {
  if (type === "outer") {
    return (
      <div styleName="outer-wrapper" className="outer-wrapper">
        <span styleName={`title-main ${publisherAttributes.lang}-title `}>{label}</span>
      </div>
    );
  }

  const contentView = (
    <React.Fragment>
      <span styleName={`${isActive ? "title-active" : "title"} ${publisherAttributes.lang}-title `}>{label}</span>
      {isNavigateIcon ? <NavigateIcon /> : null}
    </React.Fragment>
  );

  return type === "saved_news" ? (
    <Link styleName="inner-wrapper" className="inner-wrapper" href={href} target="_blank" rel="noopener noreferrer">
      {contentView}
    </Link>
  ) : (
    <Link styleName="inner-wrapper" className="inner-wrapper" href={href}>
      {contentView}
    </Link>
  );
};

ProfileMenuItem.defaultProps = {
  isActive: false,
  isNavigateIcon: false,
  type: "inner",
};

ProfileMenuItem.propTypes = {
  label: string.isRequired,
  href: string,
  isActive: bool,
  isNavigateIcon: bool,
  type: string,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(ProfileMenuItem);
